module.exports = __webpack_public_path__ + "img/makeawish_site_310X588.832d47f3.jpg";